import { render } from "./slider.vue?vue&type=template&id=3372cd2c"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"
script.render = render

export default script